<template>
  <div class="link-container" @click="goToLink">
    <router-link class="link" v-bind:to="to" >{{tranlatedTitle}}</router-link>
  </div>
</template>

     
<script>

export default {
  name: 'drawer-link',
  props:{
    title:{default:""},
    to:{default:""},
  },
  data:function(){
    return {
    }
  },
  methods:{
    goToLink(){
      this.$router.push({path:this.to});
    }
  },
  computed:{
    tranlatedTitle:function(){
      if(this.title.indexOf('language.')!==-1){
        return this.$t(this.title)
      }else{
        return this.title
      }
      
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.link{
  color:#000000!important;
  text-decoration: none;
  font-size:inherit!important;
}
.link-container{
  padding-left:20px;
  padding-top:10px;
  padding-bottom:10px;
  cursor:pointer;
}
</style>
